import {AbstractControl, FormControl, FormGroup, ValidatorFn} from '@angular/forms';
import * as moment from "moment";

function isEmptyInputValue(value: any): boolean {
  // we don't check for string here so it also works with arrays
  return value == null || value.length === 0;
}

const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const ONLY_NUMBERS_REGEXP = /^\d+$/;

export class CustomValidators {
  /**
   * Validator that performs email validation.
   * THIS VALIDATOR WAS COPIED FROM AGULAR 4 SOURCE CODE. REMOVE THIS VALIDATOR WHEN ANGULAR 4 GET RELEASED.
   * https://github.com/angular/angular/blob/master/packages/forms/src/validators.ts#L83
   */
  static email(control: AbstractControl): { [key: string]: boolean } {
    return EMAIL_REGEXP.test(control.value) ? null : {'email': true};
  }

  static onlyNumbers(control: AbstractControl): { [key: string]: boolean } {
    return ONLY_NUMBERS_REGEXP.test(control.value) ? null : {'onlyNumbers': true};
  }

  /**
   * Validator that requires two controls to have the same value.
   */
  static controlsMatch(controlNameA, controlNameB): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } => {
      const controlA = group.get(controlNameA);
      const controlB = group.get(controlNameB);

      if (controlA.value === controlB.value || isEmptyInputValue(controlA.value) || isEmptyInputValue(controlB.value)) {
        // Remove error from control A
        let errors = group.get(controlNameA).errors || {};
        delete errors['controlsMatch'];
        controlA.setErrors(Object.getOwnPropertyNames(errors).length === 0 ? null : errors);

        // Remove error from control B
        errors = controlB.errors || {};
        delete errors['controlsMatch'];
        controlB.setErrors(Object.getOwnPropertyNames(errors).length === 0 ? null : errors);

        return null;
      }

      const controlsMatchError = {'controlsMatch': {controlName1: controlA.value, controlName2: controlB.value}};

      // Add error to control A
      let errors = controlA.errors || {};
      errors = Object.assign(errors, controlsMatchError)
      controlA.setErrors(errors);

      // Add error to control B
      errors = controlB.errors || {};
      Object.assign(errors, controlsMatchError)
      controlB.setErrors(errors);

      return controlsMatchError;
    }
  }

  static legalAge(format?: string) {
    return (abstractControl: AbstractControl) => {
      let value = abstractControl.value;
      if (!value)
        return null;
      if (format) {
        console.log("Parsing date:", value);
        console.log("With format:", format);
        value = moment(value, format).toDate();
      }

      return ((new Date()).getFullYear() - value.getFullYear()) >= 18 ? null : {'legalAge': true};
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/validators/custom-validators.ts